import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=24c7632e&"
import script from "./RegistrationForm.ts?vue&type=script&lang=ts&"
export * from "./RegistrationForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports